import axios from 'axios';
import { getFingerprintHash } from '@fastcampus/browser-util/src/fingerprint';

const baseURL = '/.api';

export const api = axios.create({
  baseURL,
});

/**
 * @function
 * @name setAccessToken
 * @param {string} [accessToken]
 */

export const setAccessToken = (accessToken) => {
  if (accessToken) {
    api.defaults.headers.Authorization = `bearer ${accessToken}`;
  } else {
    delete api.defaults.headers.Authorization;
  }
};

export const apiClient = {
  get({ url, params, responseType }) {
    if (/.NET/g.test(navigator.userAgent)) {
      api.defaults.headers['cache-control'] = 'no-cache';
      api.defaults.headers.Pragma = 'no-cache';
    }
    return api({
      method: 'GET',
      url,
      params,
      responseType,
    });
  },
  post({ url, data }) {
    return api({
      method: 'POST',
      url,
      data,
    });
  },
  delete({ url, data }) {
    return api({
      method: 'DELETE',
      url,
      data,
    });
  },
  put({ url, data }) {
    return api({
      method: 'PUT',
      url,
      data,
    });
  },
};

class ApiError extends Error {
  constructor(message, status, cause, code) {
    super();
    this.message = message;
    this.status = status;
    this.cause = cause;
    this.code = code;
  }
  static create(e) {
    if (e.response) {
      const error = (e.response.data && e.response.data.error) || {};
      return new ApiError(
        error.message || e.message,
        error.status || e.response.status,
        error.cause || e.response.cause,
        error.code || e.code
      );
    }
    return new ApiError(e.message, e.status || -1, e);
  }
}

api.interceptors.request.use((config) => {
  return getFingerprintHash().then((fingerprint) => {
    config.headers['x-fingerprint'] = process.env.NODE_ENV !== 'e2e' ? fingerprint : 'bd4f3612d1ace7d7e30867debbec7595';
    return Promise.resolve(config);
  });
});

api.interceptors.response.use(null, function (err) {
  if (err) {
    return Promise.reject(ApiError.create(err));
  }
});
